import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";

const ComingSoon = ({ chapter = "Chapter", title = "This Chapter" }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background-ivory">
      <Header />
      <main className="flex-grow pt-32 pb-narrative-gap px-margin-mobile md:px-margin-desktop flex items-center justify-center">
        <div className="max-w-2xl mx-auto text-center py-24">
          <Reveal as="p" className="font-inter text-eyebrow text-brand-secondary uppercase mb-6">
            {chapter}
          </Reveal>
          <Reveal
            as="h1"
            delay={100}
            className="font-cormorant text-display-lg-mobile md:text-display-lg text-brand-ink mb-8"
          >
            {title}
          </Reveal>
          <Reveal delay={200} className="w-16 h-px bg-brand-gold mx-auto mb-8" />
          <Reveal
            as="p"
            delay={300}
            className="font-cormorant text-body-lg text-deep-taupe mb-10"
          >
            This chapter is being composed with care. In the meantime, we invite
            you to explore our Experiences or the Journal.
          </Reveal>
          <Reveal delay={400}>
            <Link
              to="/experiences"
              className="inline-flex items-center gap-3 border border-brand-gold px-8 py-4 text-brand-ink hover:bg-brand-ink hover:text-ink-on-dark hover:border-brand-ink transition-all duration-500"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="font-inter text-label-sm uppercase tracking-widest">
                View Experiences
              </span>
            </Link>
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ComingSoon;
